import { render, staticRenderFns } from "./openReading.vue?vue&type=template&id=f642fe92&scoped=true"
import script from "./openReading.vue?vue&type=script&lang=js"
export * from "./openReading.vue?vue&type=script&lang=js"
import style0 from "./openReading.vue?vue&type=style&index=0&id=f642fe92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f642fe92",
  null
  
)

export default component.exports